import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';

import { CreateUpdatePurchaseInvoiceDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow, {
  FormRow66,
  FormRow66R,
} from '../../../app/components/FormRow';
import CurrencyControl from '../../../app/components/CurrencyControl';
import { getMainCurrencySymbol } from '../../../utils/currencyFormatUtils';
import { CurrencyIsoTypeEnum } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface PurchaseInvoiceEditorFormGeneralFormCurrencyProps {
  purchaseInvoice?: CreateUpdatePurchaseInvoiceDto;
  propertyChange: (obj: Partial<CreateUpdatePurchaseInvoiceDto>) => void;
  readOnly?: boolean;
}

const currencyOptions = Object.entries(CurrencyIsoTypeEnum).map(
  ([key, value]) => ({
    value: key as CurrencyIsoTypeEnum,
    label: value,
  }),
);

export const PurchaseInvoiceGeneralFormCurrency: React.FC<
  PurchaseInvoiceEditorFormGeneralFormCurrencyProps
> = props => {
  const { t, tk } = useTranslation('fvzLng');
  const currencySelect = (
    <Select
      value={currencyOptions.find(
        ({ value }) => props.purchaseInvoice?.currency === value,
      )}
      options={currencyOptions}
      onChange={option =>
        props.propertyChange({
          currency: option?.value,
          exchangeRate: undefined,
        })
      }
      isDisabled={props.readOnly}
    />
  );

  if (props.purchaseInvoice?.currency === getMainCurrencySymbol()) {
    return (
      <FormRow controlId="currency" label={t(tk.common.currency)}>
        {currencySelect}
      </FormRow>
    );
  }

  return (
    <Row>
      <Col md={6}>
        <FormRow66 controlId="currency" label={t(tk.common.currency)}>
          {currencySelect}
        </FormRow66>
      </Col>
      <Col md={6}>
        <FormRow66R controlId="exchange" label={t(tk.common.exchangeRate)}>
          <Row>
            <Col md={6}>
              <CurrencyControl
                value={props.purchaseInvoice?.exchangeRate}
                onChange={value =>
                  props.propertyChange({
                    exchangeRate: value || undefined,
                  })
                }
                disabled={props.readOnly}
                decimalScale={
                  currencyOptions.find(
                    ({ value }) => props.purchaseInvoice?.currency === value,
                  )?.value === CurrencyIsoTypeEnum.HUF
                    ? 6
                    : 4
                }
              />
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              <a
                href="https://kalkulator-walut.groupone.pl/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(tk.attachment.calculatorCurrency)}
              </a>
            </Col>
          </Row>
        </FormRow66R>
      </Col>
    </Row>
  );
};
